var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('swiper',{ref:"swiper",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.slides),function(item,index){return _c('swiper-slide',{key:index},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item),expression:"item"}]})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }